// import components
import { styled, Box, alpha } from '@mui/material';

export const StyledContextMenuBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  borderRadius: theme.shape.borderRadius
}));

export const StyledContextMenuButton = styled('button')(({ theme }) => ({
  padding: theme.spacing(1),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  width: '30px',
  height: ' 30px',

  '&:hover ': {
    backgroundColor: alpha(theme.palette.common.black, 0.04)
  }
}));
